module.exports = __webpack_public_path__ + "img/avatar4.f9c579f8.png";